<style lang="scss">

</style>

<template>
  <section>
    <p>Please enter the details for your contact</p>

    <validation-observer ref="visitorInfoForm">
      <validation-provider #default="{ errors }" name="Relationship" rules="required">
        <label>Select contact's relationship to the {{ $options.filters.term('prisoner') }}</label>
        <b-form-select @input="setVuexProp($event, 'relationship')" class="mb-1"
                       :state="errors.length > 0 ? false:null"
                       :value="offsiteContact.relationship">
          <option disabled value="">Please select a relationship type</option>
          <option :key="item" v-for="item in relationships" :value="item">{{ item }}</option>
        </b-form-select>

        <small class="text-danger d-block my-1">{{ errors[0] }}</small>
      </validation-provider>

      <validation-provider #default="{ errors }" name="Offsite Establishment" rules="required">
        <label>Select inter-prison contact's establishment</label>
        <b-form-select @input="researchEstablishments($event)" class="mb-1"
                       :state="errors.length > 0 ? false:null"
                       :value="offsiteContact.offsite_id">
          <option disabled value="">Please select an establishment</option>
          <option :key="item.value" v-for="item in sites" :value="item.value">{{ item.text }}</option>
        </b-form-select>

        <small class="text-danger d-block my-1">{{ errors[0] }}</small>
      </validation-provider>

      <!--   If visitors exist, allow them to select one   -->
      <section v-if="offsiteContact.offsite_id && offsiteVisitors.length > 0">
        <validation-provider v-if="!manualEntry" #default="{ errors }" name="Offsite Contact" rules="required">
          <label>Select an existing person at establishment</label>
          <b-form-select @input="setExistingVisitor($event)" class="mb-2"
                         :state="errors.length > 0 ? false:null"
                         :value="existingOffsiteVisitor">
            <option disabled :value="null">Please select a person from the establishment</option>
            <option :key="item.value" v-for="item in offsiteVisitors" :value="item">
              {{item.firstname}} {{item.lastname}}
            </option>
          </b-form-select>
          <small class="text-danger d-block my-1">{{ errors[0] }}</small>
        </validation-provider>
       <section>
         <p v-if="!manualEntry">Can't see person to add as contact?
           <span @click="setManualVisitorEntry(true)" class="btn-link pointer">Enter details manually</span>
         </p>
         <p v-else>Want to recheck the list?
           <span @click="setManualVisitorEntry(false)" class="btn-link pointer">Switch to select</span>
         </p>
       </section>
      </section>

      <section v-if="manualEntry">
        <validation-provider #default="{ errors }" name="First name" rules="required">
          <label>Contact first name</label>
          <b-form-input @input="setVuexProp($event, 'firstname')" placeholder="Enter first name"
                        :state="errors.length > 0 ? false:null" class="mb-1"
                        :value="offsiteContact.firstname"/>
          <small class="text-danger d-block my-1">{{ errors[0] }}</small>
        </validation-provider>

        <validation-provider #default="{ errors }" name="Last name" rules="required">
          <label>Contact last name</label>
          <b-form-input @input="setVuexProp($event, 'lastname')" placeholder="Enter last name"
                        :state="errors.length > 0 ? false:null" class="mb-1"
                        :value="offsiteContact.lastname"/>
          <small class="text-danger d-block my-1">{{ errors[0] }}</small>
        </validation-provider>

        <validation-provider #default="{ errors }" name="Date of birth" rules="required">
          <label>Contact DOB</label>
          <b-form-datepicker
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            :state="errors.length > 0 ? false:null"
            :value="offsiteContact.dob"
            class="mb-1"
            @input="setVuexProp($event, 'dob')"
          />
          <small class="text-danger d-block my-1">{{ errors[0] }}</small>
        </validation-provider>

        <validation-provider #default="{ errors }" name="Pre Call Password" rules="required">
          <label>Contact Pre Call Password <small>(Typically contact's {{ $options.filters.term('prisoner') }} number if
            a {{ $options.filters.term('prisoner') }})</small></label>
          <b-form-input @input="setVuexProp($event, 'offsite_identifier')" placeholder="Enter precall password"
                        :state="errors.length > 0 ? false:null" class="mb-1"
                        :value="offsiteContact.offsite_identifier"/>
          <small class="text-danger d-block my-1">{{ errors[0] }}</small>
        </validation-provider>
      </section>

      <section class="d-flex full-width justify-content-end" :class="{'disabled': loading}">
        <button class="btn btn-danger mr-2" @click="setStage(2)">Back</button>
        <button class="btn btn-primary" @click="visitorInfoStageValidation()">Add Contact</button>
      </section>
    </validation-observer>
  </section>
</template>

<script>
import {mapState} from 'vuex';
import Relationships from '@/components/bookVisit/relationships';
import VisitorService from '@/services/VisitorService';
import ContactService from '@/services/ContactService';

export default {
  props: {},
  components: {},
  computed: {
    ...mapState({
      prisonerNumber: state => state.booking.offsiteBooking.prisonerNumber,
      offsiteContact: state => state.booking.offsiteContact,
      sites: state => state.booking.offsiteEstablishments,
      stage: state => state.booking.offsiteStage,
      offsiteVisitors: state => state.booking.offsiteVisitors,
      manualEntry: state => state.booking.manualVisitorEntry,
      existingOffsiteVisitor: state => state.booking.existingOffsiteVisitor,
    }),
  },
  data() {
    return {
      relationships: Relationships,
      loading: false,
    };
  },
  mounted() {
    this.setVuexProp(this.prisonerNumber, 'prisoner_number');
  },
  methods: {
    setStage(number) {
      this.$store.commit('booking/SET_OFFSITE_STAGE', number);
    },
    visitorInfoStageValidation() {
      this.$refs.visitorInfoForm.validate().then(success => {
        if (success) {
          if (this.existingOffsiteVisitor) { // add new contact only
            this.createContact();
          } else { // add new visitor (creates contact also on endpoint)
            this.createVisitorAndContact();
          }
        }
      });
    },
    createVisitorAndContact() {
      this.loading = true;
      VisitorService.registerOffsiteVisitor(this.offsiteContact).then((res) => {
        this.emitContact(res.data.contact);
      }).catch((err) => {
        let msg = 'Error creating contact, please check details and try again';
        const error = err && err.response && err.response.data;

        if (error && err.response.data.error === 'ENTITY_ALREADY_EXISTS') {
          msg = `Could not create contact as they are already a contact of this ${this.$options.filters.term('prisoner')}`;
        }
        this.$toast.error(msg, {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    createContact() {
      this.loading = true;
      const c = this.offsiteContact;
      ContactService.createContact({
        user_id: this.existingOffsiteVisitor.user_id,
        prisoner: {
          firstname: c.prisoner_firstname,
          lastname: c.prisoner_lastname,
        },
        ...c,
      }).then((res) => {
        this.emitContact(res.data);
      }).catch((err) => {
        let msg = 'Error creating contact, please check details and try again';
        const error = err && err.response && err.response.data;

          if (error && err.response.data.error === 'DUPLICATE_PRISONER_NUMBER') {
            msg = `Could not create contact as they are already a contact of this
            ${this.$options.filters.term('prisoner')}`;
          }
        this.$toast.error(msg, {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    emitContact(contact) {
      this.$toast.success('Successfully created Contact', {
        toastClassName: ['toast-std', 'success-toast'],
      });
      this.setContact(contact);
      this.$emit('contact', contact);
    },
    setContact(contact) {
      this.$store.commit('booking/SET_CONTACTS', [...this.$store.state.booking.contacts, contact]);
      this.$store.commit('booking/SET_VISITOR', contact);
    },
    setManualVisitorEntry(value) {
      this.$store.commit('booking/SET_MANUAL_VISITOR_ENTRY', value);

      // reset contact fields
      this.setOffsiteContactFields('', '', '', '');
    },
    presetContactFieldsFromExisting() {
      const v = this.existingOffsiteVisitor;
      if (v) {
        this.setOffsiteContactFields(v.firstname, v.lastname, v.dob, v.offsite_identifier);
      }
    },
    setOffsiteContactFields(firstname, lastname, dob, offsiteIdentifier) {
      this.setVuexProp(firstname, 'firstname');
      this.setVuexProp(lastname, 'lastname');
      this.setVuexProp(dob, 'dob');
      this.setVuexProp(offsiteIdentifier, 'offsite_identifier');
    },
    researchEstablishments(e) {
      this.setVuexProp(e, 'offsite_id');
      this.$store.dispatch('booking/refreshEstablishmentUsers', e);
    },
    setVuexProp(e, prop) {
      this.$store.commit('booking/SET_OFFSITE_CONTACT_ITEM', {prop, value: e});
    },
    setExistingVisitor(e) {
      this.$store.commit('booking/SET_EXISTING_OFFSITE_VISITOR', e);
      this.presetContactFieldsFromExisting();
    }
  },
};
</script>
